import React from "react";
import styles from "./Search.module.css";
const Search = () => {
  return (
    <div className={styles.container}>
      <p>Search what you want😁👉🏻</p>
      <input placeholder="search ..." />
    </div>
  );
};

export default Search;
